export default {
    //日语
    DiagnosticReport:'診断レポート',
    troubleCode:'こしょうコード',
    time:'時間',
    // 语言
    lang:{
        cn:'中国語',
        de:'ドイツ語',
        en:'英語',
        es:'スペイン語',
        fr:'フランス語',
        it:'イタリア語',
        ja:'日本語',
        ko:'韓国語',
        pt:'ポルトガル語'
    },
    PositioningPrompt:'位置情報機能をオンにして現地価格を取得します',
    FaultCode:'故障コード',
    AIDiagnosis:'AI診断',
    AIWait:'AIレポートまたは自動診断待ち',
    FailedFaultCode:'故障コード情報の取得ができません',
    AIError:'AI分析失敗',
    more:'もっと',
    StoredCodes:'コードを保存する',
    PendingCodes:'処理待ちコード',
    PermanentCodes:'永久コード',
    Unknown:'未知の',
    ManufacturerControl:'メーカーコントロール'
}